(function () {
    
    // ToDo сделать возможность использовать колбэки для МБ
    
    const useMindbox = true; // Флаг использования событий mindbox
    const useYandex = true; // Флаг использования событий Яндекс Метрики
    window.showAnalyticsLog = false; // Показать лог ошибок. Поменять здесь или динамически в консоли
    
    
    // --- Майндбокс
    
    if (useMindbox) {
        
        /**
         * @namespace
         * @desc Пространство имен для функций, связанных с Mindbox.
         * @readonly
         * @type {Object}
         * @property {function} subscriptionBookGift - Обрабатывает подписку на темы Alpinabook в качестве подарка за книги.
         * @property {function} eventTrigger - Запускает событие в Mindbox.
         * @property {function} eventError - Обрабатывает ошибки, связанные с событиями Mindbox.
         * @memberof window
         * @global
         */
        window.ab_mindbox = {
            
            /**
             * Отправляет данные в mindbox после заполнения формы "Дарим книгу за подписку".
             * Эл. почта будет подписана на все тематики рассылки
             *
             * @function
             * @name subscriptionBookGift
             * @param {Object} [data={}] - Дополнительные данные для подписки.
             * @param {string} data.email - Email для подписки.
             * @returns {void}
             * @memberof window.ab_mindbox
             * @example
             * window.ab_mindbox.subscriptionBookGift({ email: 'user@example.com' });
             */
            subscriptionBookGift: function(data = {}) {
                if ('email' in data && data.email) {
                    ab_mindbox.eventTrigger({
                        operation: "Website.ClientSubsDarimKnigu",
                        data: {
                            customer: {
                                email: data.email,
                                subscriptions: [
                                    {
                                        brand: "Alpinabook",
                                        pointOfContact: "Email",
                                        topic: "Promoactions"
                                    },
                                    {
                                        brand: "Alpinabook",
                                        pointOfContact: "Email",
                                        topic: "alpinakids"
                                    },
                                    {
                                        brand: "Alpinabook",
                                        pointOfContact: "Email",
                                        topic: "alpinamedia"
                                    },
                                    {
                                        brand: "Alpinabook",
                                        pointOfContact: "Email",
                                        topic: "yurlitsa"
                                    },
                                    {
                                        brand: "Alpinabook",
                                        pointOfContact: "Email",
                                        topic: "alpinasci-pop"
                                    },
                                    {
                                        brand: "Alpinabook",
                                        pointOfContact: "Email",
                                        topic: "alpinabusiness"
                                    },
                                    {
                                        brand: "Alpinabook",
                                        pointOfContact: "Email",
                                        topic: "alpinaself"
                                    },
                                    {
                                        brand: "Alpinabook",
                                        pointOfContact: "Email",
                                        topic: "alpinaprose"
                                    }
                                ]
                            }
                        }
                    });
                    
                } else {
                    ab_mindbox.eventError('в событие не передан параметр email', {event: event, eventData: data});
                }
            },

            /**
             * Отправляет данные в mindbox после заполнения формы "Вы нравится ли вебинар?"
             * Эл. почта будет подписана на тематику "Лекторий"
             * 
             * @function
             * @name doYouLikeWebinar
             * @param {Object} [data={}] - Дополнительные данные для подписки.
             * @param {string} data.email - Email для подписки.
             * @returns {void}
             * @memberof window.ab_mindbox
             * @example
             * window.ab_mindbox.doYouLikeWebinar({ email: 'user@example.com; });
             */
            doYouLikeWebinar: function(data = {}) {
                if ('email' in data && data.email) {
                    ab_mindbox.eventTrigger({
                        operation: "Website.ClientDoYouLikeWebinar",
                        data: {
                            customer: {
                                email: data.email,
                                subscriptions: [
                                    {
                                        brand: "alpinabook",
                                        pointOfContact: "Email",
                                        topic: "Lektoriy"
                                    }
                                ]
                            }
                        }
                    });
                } else {
                    ab_mindbox.eventError('в событие не передан параметр email', {event: event, eventData: data});
                }
            },
    
            /**
             * Отправляет в Mindbox событие просмотра лендинга подписки
             *
             * @function
             * @name subsLandingView
             * @returns {void}
             * @memberof window.ab_mindbox
             * @example
             * window.ab_mindbox.subsLandingView();
             */
            subsLandingView: function() {
                ab_mindbox.eventTrigger({
                    operation: 'Client.ViewSamorazvitie'
                });
            },
    
            /**
             * Отправляет в Mindbox событие просмотра каталога Лектория
             *
             * @function
             * @name lectoriiPageView
             * @returns {void}
             * @memberof window.ab_mindbox
             * @example
             * window.ab_mindbox.lectoriiPageView();
             */
            lectoriiPageView: function() {
                ab_mindbox.eventTrigger({
                    operation: 'Client.ViewLektoriy'
                });
            },
    
            /**
             * Отправляет в Mindbox событие просмотра страницы товара Лектория
             *
             * @function
             * @name lectoriiDetailView
             * @returns {void}
             * @memberof window.ab_mindbox
             * @example
             * window.ab_mindbox.lectoriiDetailView({  offerId: 123 });
             */
            lectoriiDetailView: function(data = {}) {
                ab_mindbox.eventTrigger({
                    operation: "ViewProduct",
                    data: {
                        viewProduct: {
                            product: {
                                ids: {
                                    alpinabook: data.offerId,
                                }
                            }
                        }
                    }
                });
            },
            
            /**
             * Отправляет в Mindbox событие входа в личный кабинет
             *
             * @function
             * @name authUserLogin
             * @returns {void}
             * @memberof window.ab_mindbox
             * @example
             * window.ab_mindbox.authUserLogin({ userId: 'someUserId' });
             */
            authUserLogin: function(data) {
                const evCustomerData = {
                    useridalp: data.userId,
                };
                if (data.email) {
                    evCustomerData.email = data.email;
                }
                if (data.phone) {
                    evCustomerData.mobilePhone = data.phone;
                }
                
                ab_mindbox.eventTrigger({
                    operation: 'Authorization',
                    data: {
                        customer: {
                            ids: evCustomerData
                        }
                    }
                });
            },
            
            /**
             * Отправляет в Mindbox событие регистрации пользователя
             *
             * @function
             * @name authUserRegister
             * @returns {void}
             * @memberof window.ab_mindbox
             * @example
             * window.ab_mindbox.authUserRegister({ userId: 'someUserId' });
             */
            authUserRegister: function(data) {
                const evCustomerData = {
                    ids: {
                        useridalp: data.userId,
                        mobilePhone: data.phone,
                    },
                };
                if (data.consentSubscription) {
                    evCustomerData.subscriptions = [{
                        brand: "Alpinabook",
                        pointOfContact: "email",
                        valueByDefault: "false",
                        isSubscribed: "true",
                    }];
                }
                ab_mindbox.eventTrigger({
                    operation: 'Registration',
                    data: {
                        customer: evCustomerData
                    }
                });
            },
            
            /**
             * Отправляет в Mindbox событие изменения корзины Лектория
             *
             * @function
             * @name lectoriiBasketChange
             * @returns {void}
             * @memberof window.ab_mindbox
             * @example
             * window.ab_mindbox.lectoriiBasketChange({ products: [{ offerId: 123, count: 1, price: 1500 }] });
             */
            lectoriiBasketChange: function(data) {
                const productsList = [];
                for (let i = 0; i < data.items.length; i++) {
                    productsList.push({
                        product: {
                            ids: {
                                alpinabook: '' + data.items[i].offerId,
                            }
                        },
                        count: '' + data.items[i].quantity,
                        pricePerItem: '' + data.items[i].price,
                    });
                }
                
                ab_mindbox.eventTrigger({
                    operation: 'Website.SetCartLektoriy',
                    data: {
                        productList: productsList
                    }
                });
            },
    
            /**
             * Запускает событие в Mindbox.
             *
             * @function
             * @name eventTrigger
             * @param {Object} [data={}] - Финальный объект данных, который будет отправлен в Mindbox.
             * @memberof window.ab_mindbox
             * @returns {void}
             * @example
             * window.ab_mindbox.eventTrigger({ operation: 'someOperation', data: { key: 'value' } });
             */
            eventTrigger: function(data = {}) {
                mindbox('async', data);
            },
    
            /**
             * Обрабатывает ошибки, связанные с событиями Mindbox.
             *
             * @function
             * @name eventError
             * @param {string} message - Сообщение об ошибке.
             * @param {Object} data - Данные, переданные в метод, вызвавший ошибку.
             * @memberof window.ab_mindbox
             * @returns {void}
             * @example
             * window.ab_mindbox.eventError('не хватает параметра param', { event: 'someEvent', eventData: { key: 'value' } });
             */
            eventError: function(message, data) {
                // Метод на случай более сложной обработки ошибок
                // Пока что просто вывод в консоль
                if (showAnalyticsLog) {
                    console.log('Ошибка события mindbox:', message);
                    if (data)
                        console.log(data);
                }
            }
        };
    }
    
    
    // --- Яндекс Метрика
    
    if (useYandex) {
        /**
         * @namespace
         * @desc Пространство имен для функций, связанных с Яндекс Метрикой.
         * @readonly
         * @type {Object}
         * @property {function} subsLandingAnchorClick - Лендинг подписки. Событие клика по якорю "Попробовать бесплатно".
         * @property {function} subsLandingAppstoreClick - Лендинг подписки. Событие клика по скачиванию приложения App Store.
         * @property {function} subsLandingGoogleplayClick - Лендинг подписки. Событие клика по скачиванию приложения Google Play.
         * @property {function} subsLandingBuyClick - Лендинг подписки. Событие клика по покупке тарифа.
         * @property {function} eventTrigger - Запускает событие в Метрику.
         * @property {function} eventError - Обрабатывает ошибки, связанные с событиями Метрики.
         * @memberof window
         * @global
         */
    
        window.ab_ya_metrics = {
            
            /**
             * Отправляет событие в Яндекс Метрику о нажатии на ссылку Лекторий в шапке
             *
             * @function
             * @name lectoriiLinkClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.lectoriiLinkClick();
             */
            lectoriiLinkClick: function() {
                ab_ya_metrics.eventTrigger('Lectorium');
            },
            
            /**
             * Отправляет событие в Яндекс Метрику о нажатии на ссылку Подписка в шапке
             *
             * @function
             * @name subscribeLinkClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.subscribeLinkClick();
             */
            subscribeLinkClick: function() {
                ab_ya_metrics.eventTrigger('Podpiska');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о нажатии на кнопку Получить код в модалке сбора почты во время авторизации
             *
             * @function
             * @name authRequestCode
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.authRequestCode();
             */
            authRequestCode: function() {
                ab_ya_metrics.eventTrigger('getcode');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику об отправке валидной почты в модалке сбора почты во время авторизации
             *
             * @function
             * @name authSendValidEmail
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.authSendValidEmail();
             */
            authSendValidEmail: function() {
                ab_ya_metrics.eventTrigger('getemail');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику об отправке почты при попытке заказа в лектории (покупка, подписка на бесплатный вебинар, оформление подарка)
             *
             * @function
             * @name authSendValidEmailLectorii
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.authSendValidEmailLectorii();
             */
            authSendValidEmailLectorii: function() {
                ab_ya_metrics.eventTrigger('get_email_Lectorium');
            },
        
            /**
             * Отправляет событие в Яндекс Метрику о клике на якорь "Попробовать бесплатно" на лендинге подписки
             *
             * @function
             * @name subsLandingAnchorClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.subsLandingAnchorClick();
             */
            subsLandingAnchorClick: function() {
                ab_ya_metrics.eventTrigger('Podpiskatryfree');
            },
        
            /**
             * Отправляет событие в Яндекс Метрику о клике на кнопку скачивания приложения Appstore на лендинге подписки
             *
             * @function
             * @name subsLandingAppstoreClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.subsLandingAppstoreClick();
             */
            subsLandingAppstoreClick: function() {
                ab_ya_metrics.eventTrigger('PodpiskaDownloadAppStore');
            },
        
            /**
             * Отправляет событие в Яндекс Метрику о клике на кнопку скачивания приложения Google Play на лендинге подписки
             *
             * @function
             * @name subsLandingGoogleplayClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.subsLandingGoogleplayClick();
             */
            subsLandingGoogleplayClick: function() {
                ab_ya_metrics.eventTrigger('PodpiskaDownloadGooglePlay');
            },
        
            /**
             * Отправляет событие в Яндекс Метрику о клике на кнопку покупки тарифа
             *
             * @function
             * @name subsLandingBuyClick
             * @param {Object} [data={}] - Дополнительные данные для подписки.
             * @param {string} data.tariffIndex - Индекс тарифа.
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.subsLandingBuyClick({ tariffIndex: '1' });
             */
            subsLandingBuyClick: function(data = {}) {
                let evCode;
                switch (data.tariffIndex) {
                    case '1':
                        evCode = 'Podpiskatryfree490';
                        break;
                    case '2':
                        evCode = 'Podpiskatryfree1190';
                        break;
                    case '3':
                        evCode = 'Podpiskatryfree3990';
                        break;
                }
                
                if (evCode) {
                    ab_ya_metrics.eventTrigger(evCode);
                }
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о клике на ссылку "Читать по подписке..." в деталке
             *
             * @function
             * @name detailLinkToSubsLandingClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.detailLinkToSubsLandingClick();
             */
            detailLinkToSubsLandingClick: function() {
                ab_ya_metrics.eventTrigger('dostupno_po_podpiska_book');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о клике на ссылку "Читать по подписке..." в превью товара в блоге
             *
             * @function
             * @name blogLinkToSubsLandingClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.blogLinkToSubsLandingClick();
             */
            blogLinkToSubsLandingClick: function() {
                ab_ya_metrics.eventTrigger('blog_preview_subscription_link_click');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о клике на кнопку "В корзину" в детальной карточке лекции
             *
             * @function
             * @name lectoriiBuyClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.lectoriiBuyClick();
             */
            lectoriiBuyClick: function() {
                ab_ya_metrics.eventTrigger('clickonbasketlectures');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о клике на кнопку "Участвовать" у бесплатного вебинара
             *
             * @function
             * @name lectoriiFreeWebinarClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.lectoriiFreeWebinarClick();
             */
            lectoriiFreeWebinarClick: function() {
                ab_ya_metrics.eventTrigger('click_Join_lectorii');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о заполнении формы заказа у бесплатного вебинара
             *
             * @function
             * @name lectoriiFreeWebinarFormOrderSubmit
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.lectoriiFreeWebinarFormOrderSubmit();
             */
            lectoriiFreeWebinarFormOrderSubmit: function() {
                ab_ya_metrics.eventTrigger('clickonattendwebinar_newreg');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о нажатии на кнопку "Купить и подарить" в Лектории
             *
             * @function
             * @name lectoriiGiftBtnClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.lectoriiGiftBtnClick();
             */
            lectoriiGiftBtnClick: function() {
                ab_ya_metrics.eventTrigger('clickonbuy&give');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о клике на якорь "Записаться на курс" на лендинге курса "Эмоциональное выгорание"
             *
             * @function
             * @name landEmoFreedomAnchorToBuyClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.landEmoFreedomAnchorToBuyClick();
             */
            landEmoFreedomAnchorToBuyClick: function() {
                ab_ya_metrics.eventTrigger('click_zapis_course_emotfreedom');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о клике на стрелку слайдера на лендинге курса "Эмоциональное выгорание"
             *
             * @function
             * @name landEmoFreedomSliderArrowClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.landEmoFreedomSliderArrowClick();
             */
            landEmoFreedomSliderArrowClick: function() {
                ab_ya_metrics.eventTrigger('click_howteaching_course_emotfreedom');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о клике на кнопку отправки формы лидгенератора с видео на лендинге курса "Эмоциональное выгорание"
             *
             * @function
             * @name landEmoFreedomLeadFormVideoClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.landEmoFreedomLeadFormVideoClick();
             */
            landEmoFreedomLeadFormVideoClick: function() {
                ab_ya_metrics.eventTrigger('click_getlidmagnitweb_course_emotfreedom');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о клике на кнопку отправки формы лидгенератора с чеклистом на лендинге курса "Эмоциональное выгорание"
             *
             * @function
             * @name landEmoFreedomLeadFormChecklistClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.landEmoFreedomLeadFormChecklistClick();
             */
            landEmoFreedomLeadFormChecklistClick: function() {
                ab_ya_metrics.eventTrigger('click_getlidmagnitchecklist_course_emotfreedom');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о клике на кнопку "Записаться..." на тариф Базовый на лендинге курса "Эмоциональное выгорание"
             *
             * @function
             * @name landEmoFreedomBuyBaseClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.landEmoFreedomBuyBaseClick();
             */
            landEmoFreedomBuyBaseClick: function() {
                ab_ya_metrics.eventTrigger('click_zapis_BasePrice_course_emotfreedom');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о клике на кнопку "Записаться..." на тариф Персональный на лендинге курса "Эмоциональное выгорание"
             *
             * @function
             * @name landEmoFreedomBuyPersonalClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.landEmoFreedomBuyPersonalClick();
             */
            landEmoFreedomBuyPersonalClick: function() {
                ab_ya_metrics.eventTrigger('click_zapis_PersonPrice_course_emotfreedom');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о попытке отправки формы обратной связи на лендинге курса "Эмоциональное выгорание"
             *
             * @function
             * @name landEmoFreedomFeedbackClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.landEmoFreedomFeedbackClick();
             */
            landEmoFreedomFeedbackClick: function() {
                ab_ya_metrics.eventTrigger('click_getcons_course_emotfreedom');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о клике на кнопку телеграм-канала на лендинге курса "Эмоциональное выгорание"
             *
             * @function
             * @name landEmoFreedomTelegramClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.landEmoFreedomTelegramClick();
             */
            landEmoFreedomTelegramClick: function() {
                ab_ya_metrics.eventTrigger('click_substg_course_emotfreedom');
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о клике кнопку видео спикера на лендинге курса "Эмоциональное выгорание"
             *
             * @function
             * @name landEmoFreedomSpeakerClick
             * @param {Object} [data={}] - Дополнительные данные для cобытия.
             * @param {string} data.operationIndex - Индекс спикера.
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.landEmoFreedomSpeakerClick({ operationIndex: '1' });
             */
            landEmoFreedomSpeakerClick: function(data = {}) {
                if ('operationIndex' in data && data.operationIndex > 0) {
                    ab_ya_metrics.eventTrigger(`click_Coach_${data.operationIndex}_course_emotfreedom`);
                } else {
                    ab_ya_metrics.eventError('в событие не передан параметр operationIndex', {eventData: data});
                }
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о клике кнопку разворачивания модуля на лендинге курса "Эмоциональное выгорание"
             *
             * @function
             * @name landEmoFreedomModuleClick
             * @param {Object} [data={}] - Дополнительные данные для cобытия.
             * @param {string} data.operationIndex - Индекс модуля.
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.landEmoFreedomModuleClick({ operationIndex: '1' });
             */
            landEmoFreedomModuleClick: function(data = {}) {
                if ('operationIndex' in data && data.operationIndex > 0) {
                    // Триггер только на модули после первого
                    if (data.operationIndex > 1) {
                        ab_ya_metrics.eventTrigger(`click_Molule${data.operationIndex}_course_emotfreedom`);   
                    }
                } else {
                    ab_ya_metrics.eventError('в событие не передан параметр operationIndex', {eventData: data});
                }
            },
    
            /**
             * Отправляет событие в Яндекс Метрику о клике на кнопку в баннере подписки
             *
             * @function
             * @name bannerSubscriptionClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.bannerSubscriptionClick();
             */
            bannerSubscriptionClick: function() {
                ab_ya_metrics.eventTrigger('click_bunnerPodpiska');
            },

            /**
             * Отправляет событие в Яндекс Метрику о клике на кнопку "Читать фрагмент" на странице книги
             * 
             * @function
             * @name readFragmentClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.readFragmentClick();
             */
            readFragmentClick: function() {
                ab_ya_metrics.eventTrigger('click_read_fragment');
            },

            /**
             * Отправляет событие в Яндекс Метрику о клике на кнопку "Перейти" или "В корзину" на детальной странице блога для товара с рамкой
             * 
             * @function
             * @name blogProductWithBorderClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.blogProductWithBorderClick();
             */
            blogProductWithBorderClick: function() {
                ab_ya_metrics.eventTrigger('from_blog_to_product_with_border');
            },

            /**
             * Отправляет событие в Яндекс Метрику при переходу в карточку на детальной странице блога для товара без рамки
             * 
             * @function
             * @name blogProductWithoutBorderGoDetailClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.blogProductWithoutBorderGoDetailClick();
             */
            blogProductWithoutBorderGoDetailClick: function() {
                ab_ya_metrics.eventTrigger('go_detail_from_blog_to_product_without_border');
            },

            /**
             * Отправляет событие в Яндекс Метрику при переходу в карточку на детальной странице блога для товара с рамкой
             *
             * @function
             * @name blogProductWithBorderGoDetailClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.blogProductWithBorderGoDetailClick();
             */
            blogProductWithBorderGoDetailClick: function() {
                ab_ya_metrics.eventTrigger('go_detail_from_blog_to_product_with_border');
            },

            /**
             * Отправляет событие в Яндекс Метрику о клике на кнопку "Перейти" или "В корзину" на детальной странице блога для товара без рамки
             *
             * @function
             * @name blogProductWithoutBorderClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.blogProductWithoutBorderClick();
             */
            blogProductWithoutBorderClick: function() {
                ab_ya_metrics.eventTrigger('from_blog_to_product_without_border');
            },

            /**
             * Кнопка Подписка в шапке магазина (десктоп и моб)
             */
            alpinaPlusHeaderClick: function() {
                ab_ya_metrics.eventTrigger('click_alpina_plus_header');
            },

            /**
             * Кнопка Доступно по подписке (для неавторизованных без подписки, которая будет вести на лендинг подписки в Плюсе)
             */
            alpinaPlusCartClick: function() {
                ab_ya_metrics.eventTrigger('click_alpina_plus_cart');
            },

            /**
             * Кнопка Читать/Смотреть по подписке (для авторизованных с подпиской, которая ведет на потребление контента в плюсе)
             */
            alpinaPlusReadClick: function() {
                ab_ya_metrics.eventTrigger('click_alpina_plus_read');
            },
            
            /**
             * Деталка лектория – клик на кнопку участия в Плюсе (только для вебинаров)
             */
            webinarClickBtnPlus: function() {
                ab_ya_metrics.eventTrigger('webinar_detail_click_btn_plus');
            },
            
            /**
             * Деталка лектория – клик на кнопку участия в Корп. Библ. (только для вебинаров)
             */
            webinarClickBtnLibrary: function() {
                ab_ya_metrics.eventTrigger('webinar_detail_click_btn_library');
            },
            
            /**
             * Деталка курса – клик на любую кнопку якоря к блоку с тарифами
             */
            lectoriiCourseAnchorClick: function() {
                ab_ya_metrics.eventTrigger('Сlick-Buttom-Anchor-to-Tariff');
            },
            
            /**
             * Деталка курса – клик на любую кнопку покупки/записи в карточке тарифа
             */
            lectoriiCourseBuyClick: function() {
                ab_ya_metrics.eventTrigger('Click-Inside-Tariff');
            },
            
            /**
             * Деталка курса – клик на кнопку сабмита в форме покупки для компании
             */
            lectoriiFormCompanySubmitClick: function() {
                ab_ya_metrics.eventTrigger('Click-send-request-CourseForCompany');
            },
            
            /**
             * Лендинг Альпина.Дети – клик на кнопку "Давайте!"
             */
            detibiznesClickBtnAction: function() {
                ab_ya_metrics.eventTrigger('detibiznes_click_btn_action');
            },
            
            /**
             * Отправка отзыва для неавторизованного пользователя – показ модалки авторизации перед заполнением отзыва
             */
            reviewAddNotLogged: function() {
                ab_ya_metrics.eventTrigger('review_add_auth_before');
            },
            
            /**
             * Отправка отзыва для неавторизованного пользователя – отправка отзыва после предварительной авторизации
             */
            reviewSubmitAuthOnStart: function() {
                ab_ya_metrics.eventTrigger('review_add_submit_auth_on_start');
            },
            
            /**
             * Отправляет событие в Яндекс Метрику о клике на ссылку в блоке нижней рекламы в карточке книги
             *
             * @function
             * @name bottomAdvertClick
             * @param {Object} [data={}] - Дополнительные данные для cобытия.
             * @param {string} data.linkCode - Код для события ссылки.
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.bottomAdvertClick({ linkCode: 'deti' });
             */
            bottomAdvertClick: function(data = {}) {
                if ('linkCode' in data && data.linkCode) {
                    ab_ya_metrics.eventTrigger(`bottom_links_click_${data.linkCode}`);
                } else {
                    ab_ya_metrics.eventError('в событие не передан параметр linkCode', {eventData: data});
                }
            },
            
            /**
             * Отправляет событие в Яндекс Метрику о переходе в детальную карточку товара из превью в зависимости
             * от типа блока
             *
             * @function
             * @name bookPreviewDetailLinkClick
             * @param {Object} [data={}] - Дополнительные данные для cобытия.
             * @param {string} data.type - Код типа блока.
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.bookPreviewDetailLinkClick({ type: 'mainpagePreorder' });
             */
            bookPreviewDetailLinkClick: function(data = {}) {
                if ('type' in data && data.type) {
                    switch (data.type) {
                        case 'mainpagePreorder':
                            // Слайдер "Предзаказы" на главной странице
                            ab_ya_metrics.eventTrigger('main_page_book_preview_click_preorder');
                            break;
                            
                        case 'mainpageBestsellers':
                            // Слайдер "Бестселлеры" на главной странице
                            ab_ya_metrics.eventTrigger('main_page_book_preview_click_bestsellers');
                            break;
                            
                        case 'mainpageLatest':
                            // Слайдер "Новинки" на главной странице
                            ab_ya_metrics.eventTrigger('main_page_book_preview_click_latest');
                            break;
                            
                        default:
                            ab_ya_metrics.eventError('в событие передан некорректный параметр type', {eventData: data});
                            break;
                    }
                    
                } else {
                    ab_ya_metrics.eventError('в событие не передан параметр type', {eventData: data});
                }
            },
            
            /**
             * Отправляет событие в Яндекс Метрику о переходе в детальную карточку лектория из превью в зависимости
             * от типа блока
             *
             * @function
             * @name lecturePreviewDetailLinkClick
             * @param {Object} [data={}] - Дополнительные данные для cобытия.
             * @param {string} data.type - Код типа блока.
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.lecturePreviewDetailLinkClick({ type: 'bookDetailLectures' });
             */
            lecturePreviewDetailLinkClick: function(data = {}) {
                if ('type' in data && data.type) {
                    switch (data.type) {
                        case 'bookDetailLectures':
                            // Слайдер лектория на детальной странице книги
                            ab_ya_metrics.eventTrigger('detail_book_page_lecture_preview_click');
                            break;
                            
                        default:
                            ab_ya_metrics.eventError('в событие передан некорректный параметр type', {eventData: data});
                            break;
                    }
                    
                } else {
                    ab_ya_metrics.eventError('в событие не передан параметр type', {eventData: data});
                }
            },
            
            /**
             * Отправляет событие в Яндекс Метрику о запросе в Дадату в зависимости от источника
             *
             * @function
             * @name dadataRequestSent
             * @param {Object} [data={}] - Дополнительные данные для cобытия.
             * @param {string} data.type - Код источника.
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.dadataRequestSent({ type: 'orderAddress' });
             */
            dadataRequestSent: function(data = {}) {
                if ('type' in data && data.type) {
                    switch (data.type) {
                        case 'orderAddress':
                            // Запрос адреса через подсказки в оформлении заказа
                            ab_ya_metrics.eventTrigger('dadata_request_order_address');
                            break;
                            
                        case 'orderYurBank':
                            // Запрос банка через подсказки в оформлении заказа у юрлиц
                            ab_ya_metrics.eventTrigger('dadata_request_order_bank');
                            break;
                        
                        case 'orderYurCompany':
                            // Запрос компании в оформлении заказа у юрлиц
                            ab_ya_metrics.eventTrigger('dadata_request_order_company');
                            break;
                            
                        case 'certificateOrderBank':
                            // Запрос банка в оформлении заказа на подарочный сертификат
                            ab_ya_metrics.eventTrigger('dadata_request_cert_order_bank');
                            break;
                            
                        case 'certificateOrderCompany':
                            // Запрос компании в оформлении заказа на подарочный сертификат
                            ab_ya_metrics.eventTrigger('dadata_request_cert_order_company');
                            break;
                            
                        case 'headerLocationSuggest':
                            // Запрос местоположения в шапке через подсказки
                            ab_ya_metrics.eventTrigger('dadata_request_header_location_suggest');
                            break;
                            
                        case 'headerLocationDetect':
                            // Запрос местоположения в шапке через геопозицию
                            ab_ya_metrics.eventTrigger('dadata_request_header_location_detect');
                            break;
                            
                        default:
                            ab_ya_metrics.eventError('в событие передан некорректный параметр type', {eventData: data});
                            break;
                    }
                    
                } else {
                    ab_ya_metrics.eventError('в событие не передан параметр type', {eventData: data});
                }
            },
            
            /**
             * Отправляет событие в Яндекс Метрику о переходе с баннера подписки на главной странице
             *
             * @function
             * @name bannerSubscriptionMainPageClick
             * @returns {void}
             * @memberof window.ab_ya_metrics
             * @example
             * window.ab_ya_metrics.bannerSubscriptionMainPageClick();
             */
            bannerSubscriptionMainPageClick: function() {
                ab_ya_metrics.eventTrigger('banner_subscription_main_page_click');
            },
            
            /**
             * Запускает событие в Яндекс Метрику.
             *
             * @function
             * @name eventTrigger
             * @param {string} evCode - Код цели в Яндекс Метрике, которая достигнута.
             * @memberof window.ab_ya_metrics
             * @returns {void}
             * @example
             * window.ab_ya_metrics.eventTrigger('buttonClick');
             */
            eventTrigger: function(evCode) {
                if (typeof yaCounter1611177 !== 'undefined') {
                    yaCounter1611177.reachGoal(evCode);
                } else {
                    ab_ya_metrics.eventError('не инициализирован счётчик');
                }
            },
        
            /**
             * Обрабатывает ошибки, связанные с событиями Яндекс Метрики.
             *
             * @function
             * @name eventError
             * @param {string} message - Сообщение об ошибке.
             * @memberof window.ab_ya_metrics
             * @returns {void}
             * @example
             * window.ab_ya_metrics.eventError('неизвестная ошибка');
             */
            eventError: function(message) {
                // Метод на случай более сложной обработки ошибок
                // Пока что просто вывод в консоль
                if (showAnalyticsLog) {
                    console.log('Ошибка события Яндекс Метрики:', message);
                }
            }
        };
    }
    
    
    // --- Глобальные аналитические события
    
    /**
     * @namespace
     * @desc Пространство имен для функций, связанных с аналитикой Alpinabook.
     * @readonly
     * @type {Object}
     * @property {function} init - Инициализирует функционал аналитики.
     * @memberof window
     * @global
     */
    window.ab_analytics = {
    
        /**
         * Инициализирует функционал аналитики.
         *
         * @function
         * @name init
         * @desc Устанавливает обработчик события для аналитики.
         * @memberof window.ab_analytics
         * @returns {void}
         * @example
         * window.ab_analytics.init();
         */
        init: function() {
            /*
            Обработчик события аналитики
            Реализовано через CustomEvent, потому что удобно ловить в коде других компонентов.
            А также, в таком случае, в отличие от прямого вызова метода, при незапланированном отсутствии обработчика
            код других компонентов не будет падать с ошибкой.
            
            Вызывать так:
            
                const analyticsEvent = new CustomEvent('ab.analytics.event', {
                    bubbles: true,
                    cancelable: true,
                    detail: {
                        eventCode: 'abEventCode', 
                        param1: ...,
                        param2: ...,
                        ...
                        paramN
                    }
                 });
                 element.dispatchEvent(analyticsEvent);
                 
             Обязательно указать параметр detail.eventCode – код глобального события из switch/case ниже.
             По нему определится набор методов систем аналитики, которые будут вызваны.
             
             Обязательно указать bubbles: true и cancelable: true, если событие вызвано на конкретный блок.
             Либо вызывать глобально на document. Так: document.dispatchEvent(analyticsEvent);
             
             Дополнительно в detail можно указать параметры, нужные для последующих вызовов методов событий
             */
            document.addEventListener('ab.analytics.event', function(event) {
                switch(event.detail.eventCode) {
                    
                    // Клик на ссылку Лекторий в шапке сайта
                    case 'lectoriiLinkClick':
                        if (useYandex) {
                            ab_ya_metrics.lectoriiLinkClick();
                        }
                        break;
                    
                    // Клик на ссылку Подписка в шапке сайта
                    case 'subscribeLinkClick':
                        if (useYandex) {
                            ab_ya_metrics.subscribeLinkClick();
                        }
                        break;
                    
                    // Клик по кнопке "Получить код" в попапе авторизации по телефону
                    case 'authRequestCode':
                        if (useYandex) {
                            ab_ya_metrics.authRequestCode(event.detail);
                        }
                        break;
                    
                    // Регистрация на сайте
                    case 'authUserRegister':
                        if (useMindbox) {
                            ab_mindbox.authUserRegister(event.detail);
                        }
                        break;
                    
                    // Авторизация на сайте
                    case 'authUserLogin':
                        if (useMindbox) {
                            ab_mindbox.authUserLogin(event.detail);
                        }
                        break;
                    
                    // В форме сбора почты после авторизации – отправка валидной почты
                    case 'authSendValidEmail':
                        if (useYandex) {
                            ab_ya_metrics.authSendValidEmail(event.detail);
                        }
                        break;
                    
                    // В форме сбора почты в лектории – отправка валидной почты
                    case 'authSendValidEmailLectorii':
                        if (useYandex) {
                            ab_ya_metrics.authSendValidEmailLectorii(event.detail);
                        }
                        break;
                    
                    // Просмотр лендинга подписки
                    case 'subsLandingView':
                        if (useMindbox) {
                            ab_mindbox.subsLandingView();
                        }
                        break;
                        
                    case 'doYouLikeWebinar':
                        if (useMindbox) {
                            ab_mindbox.doYouLikeWebinar(event.detail);
                        }
                        break;
                    
                    // Отправка формы "Дарим книгу за подписку" из деталки книги
                    case 'subscriptionBookGift':
                        if (useMindbox) {
                            ab_mindbox.subscriptionBookGift(event.detail);
                        }
                        break;
                        
                    // Клик на ссылку "Читать по подписке..." в деталке товара
                    case 'detailLinkToSubsLandingClick':
                        if (useYandex) {
                            ab_ya_metrics.detailLinkToSubsLandingClick();
                        }
                        break;
                        
                    // Клик на ссылку "Читать по подписке..." в превью товара в блоге
                    case 'blogLinkToSubsLandingClick':
                        if (useYandex) {
                            ab_ya_metrics.blogLinkToSubsLandingClick();
                        }
                        break;
                        
                    // Клик на якорь "Попробовать бесплатно" на странице лендинга подписки
                    case 'subsLandingAnchorClick':
                        if (useYandex) {
                            ab_ya_metrics.subsLandingAnchorClick();
                        }
                        break;
    
                    // Клик на кнопку скачивания приложения App Store на странице лендинга подписки
                    case 'subsLandingAppstoreClick':
                        if (useYandex) {
                            ab_ya_metrics.subsLandingAppstoreClick();
                        }
                        break;
    
                    // Клик на кнопку скачивания приложения Google Play на странице лендинга подписки
                    case 'subsLandingGoogleplayClick':
                        if (useYandex) {
                            ab_ya_metrics.subsLandingGoogleplayClick();
                        }
                        break;
    
                    // Клик на кнопку покупки тарифа на странице лендинга подписки
                    case 'subsLandingBuyClick':
                        if (useYandex) {
                            ab_ya_metrics.subsLandingBuyClick(event.detail);
                        }
                        break;
    
                    // Посещение страницы каталога лектория
                    case 'lectoriiPageView':
                        if (useMindbox) {
                            ab_mindbox.lectoriiPageView();
                        }
                        break;
    
                    // Посещение страницы деталки лектория
                    case 'lectoriiDetailView':
                        if (useMindbox) {
                            ab_mindbox.lectoriiDetailView(event.detail);
                        }
                        break;
    
                    // Клик на кнопку "В корзину" на детальной странице лектория
                    case 'lectoriiBuyClick':
                        if (useYandex) {
                            ab_ya_metrics.lectoriiBuyClick();
                        }
                        break;
    
                    // Клик на кнопку "Участвовать" у бесплатного вебинара
                    case 'lectoriiFreeWebinarClick':
                        if (useYandex) {
                            ab_ya_metrics.lectoriiFreeWebinarClick();
                        }
                        break;
    
                    // Заполнение формы заказа у бесплатного вебинара
                    case 'lectoriiFreeWebinarFormOrderSubmit':
                        if (useYandex) {
                            ab_ya_metrics.lectoriiFreeWebinarFormOrderSubmit();
                        }
                        break;
    
                    // Клик на кнопку "Купить и подарить" в Лектории
                    case 'lectoriiGiftBtnClick':
                        if (useYandex) {
                            ab_ya_metrics.lectoriiGiftBtnClick();
                        }
                        break;
    
                    // Изменение корзины Лектория
                    case 'lectoriiBasketChange':
                        if (useMindbox) {
                            ab_mindbox.lectoriiBasketChange(event.detail.basketData);
                        }
                        break;
    
                    // Лендинг курса "Эмоциональное выгорание" – клик на якорь "Записаться..."
                    case 'landEmoFreedomAnchorToBuyClick':
                        if (useYandex) {
                            ab_ya_metrics.landEmoFreedomAnchorToBuyClick();
                        }
                        break;
    
                    // Лендинг курса "Эмоциональное выгорание" – клик на стрелочку переключения в слайдере
                    case 'landEmoFreedomSliderArrowClick':
                        if (useYandex) {
                            ab_ya_metrics.landEmoFreedomSliderArrowClick();
                        }
                        break;
    
                    // Лендинг курса "Эмоциональное выгорание" – попытка отправки формы лидгенератора с видео
                    case 'landEmoFreedomLeadFormVideoClick':
                        if (useYandex) {
                            ab_ya_metrics.landEmoFreedomLeadFormVideoClick();
                        }
                        break;
    
                    // Лендинг курса "Эмоциональное выгорание" – попытка отправки формы лидгенератора с чеклистом
                    case 'landEmoFreedomLeadFormChecklistClick':
                        if (useYandex) {
                            ab_ya_metrics.landEmoFreedomLeadFormChecklistClick();
                        }
                        break;
    
                    // Лендинг курса "Эмоциональное выгорание" – клик на кнопку тарифа Базовый
                    case 'landEmoFreedomBuyBaseClick':
                        if (useYandex) {
                            ab_ya_metrics.landEmoFreedomBuyBaseClick();
                        }
                        break;
    
                    // Лендинг курса "Эмоциональное выгорание" – клик на кнопку тарифа Персональный
                    case 'landEmoFreedomBuyPersonalClick':
                        if (useYandex) {
                            ab_ya_metrics.landEmoFreedomBuyPersonalClick();
                        }
                        break;
    
                    // Лендинг курса "Эмоциональное выгорание" – клик на кнопку отправки формы обратной связи
                    case 'landEmoFreedomFeedbackClick':
                        if (useYandex) {
                            ab_ya_metrics.landEmoFreedomFeedbackClick();
                        }
                        break;
    
                    // Лендинг курса "Эмоциональное выгорание" – клик на кнопку перехода в телеграм
                    case 'landEmoFreedomTelegramClick':
                        if (useYandex) {
                            ab_ya_metrics.landEmoFreedomTelegramClick();
                        }
                        break;
    
                    // Лендинг курса "Эмоциональное выгорание" – клик на кнопку видео спикера
                    case 'landEmoFreedomSpeakerClick':
                        if (useYandex) {
                            ab_ya_metrics.landEmoFreedomSpeakerClick(event.detail);
                        }
                        break;
    
                    // Лендинг курса "Эмоциональное выгорание" – клик на разворачивание аккордеона модуля
                    case 'landEmoFreedomModuleClick':
                        if (useYandex) {
                            ab_ya_metrics.landEmoFreedomModuleClick(event.detail);
                        }
                        break;
    
                    // Клик на кнопку в баннере подписки
                    case 'bannerSubscriptionClick':
                        if (useYandex) {
                            ab_ya_metrics.bannerSubscriptionClick();
                        }
                        break;
                        
                    // Клик на кнопку "Читать фрагмент" на странице книги
                    case 'readFragmentClick':
                        if (useYandex) {
                            ab_ya_metrics.readFragmentClick();
                        }
                        break;
                        
                    // Клик на кнопку "Перейти" или "В корзину" на детальной странице блога для товара с рамкой
                    case 'blogProductWithBorderClick':
                        if (useYandex) {
                            ab_ya_metrics.blogProductWithBorderClick();
                        }
                        break;
                        
                    // Клик на кнопку "Перейти" или "В корзину" на детальной странице блога для товара без рамки
                    case 'blogProductWithoutBorderClick':
                        if (useYandex) {
                            ab_ya_metrics.blogProductWithoutBorderClick();
                        }
                        break;

                    // Переход в карточку товара на детальной странице блока для товара с рамкой
                    case 'blogProductWithBorderGoDetailClick':
                        if (useYandex) {
                            ab_ya_metrics.blogProductWithBorderGoDetailClick();
                        }
                        break;

                    // Переход в карточку товара на детальной странице блока для товара без рамки
                    case 'blogProductWithoutBorderGoDetailClick':
                        if (useYandex) {
                            ab_ya_metrics.blogProductWithoutBorderGoDetailClick();
                        }
                        break;

                    case 'alpinaPlusHeaderClick':
                        if (useYandex) {
                            ab_ya_metrics.alpinaPlusHeaderClick();
                        }
                        break;

                    case 'alpinaPlusCartClick':
                        if (useYandex) {
                            ab_ya_metrics.alpinaPlusCartClick();
                        }
                        break;

                    case 'alpinaPlusReadClick':
                        if (useYandex) {
                            ab_ya_metrics.alpinaPlusReadClick();
                        }
                        break;

                    case 'webinarClickBtnPlus':
                        if (useYandex) {
                            ab_ya_metrics.webinarClickBtnPlus();
                        }
                        break;

                    case 'webinarClickBtnLibrary':
                        if (useYandex) {
                            ab_ya_metrics.webinarClickBtnLibrary();
                        }
                        break;

                    case 'lectoriiCourseAnchorClick':
                        if (useYandex) {
                            ab_ya_metrics.lectoriiCourseAnchorClick();
                        }
                        break;

                    case 'lectoriiCourseBuyClick':
                        if (useYandex) {
                            ab_ya_metrics.lectoriiCourseBuyClick();
                        }
                        break;

                    case 'lectoriiFormCompanySubmitClick':
                        if (useYandex) {
                            ab_ya_metrics.lectoriiFormCompanySubmitClick();
                        }
                        break;

                    case 'detibiznesClickBtnAction':
                        if (useYandex) {
                            ab_ya_metrics.detibiznesClickBtnAction();
                        }
                        break;
                    
                    // Детальная карточка книги – Нажатие на ссылку в блоке рекламы внизу страницы
                    case 'bottomAdvertClick':
                        if (useYandex) {
                            ab_ya_metrics.bottomAdvertClick(event.detail);
                        }
                        break;
                        
                    case 'reviewAddNotLogged':
                        if (useYandex) {
                            ab_ya_metrics.reviewAddNotLogged();
                        }
                        break;
                        
                    case 'reviewSubmitAuthOnStart':
                        if (useYandex) {
                            ab_ya_metrics.reviewSubmitAuthOnStart();
                        }
                        break;
                        
                    case 'bookPreviewDetailLinkClick':
                        if (useYandex) {
                            ab_ya_metrics.bookPreviewDetailLinkClick(event.detail);
                        }
                        break;
                        
                    case 'lecturePreviewDetailLinkClick':
                        if (useYandex) {
                            ab_ya_metrics.lecturePreviewDetailLinkClick(event.detail);
                        }
                        break;
                        
                    case 'dadataRequestSent':
                        if (useYandex) {
                            ab_ya_metrics.dadataRequestSent(event.detail);
                        }
                        break;
                        
                    case 'bannerSubscriptionMainPageClick':
                        if (useYandex) {
                            ab_ya_metrics.bannerSubscriptionMainPageClick();
                        }
                        break;
                        
                    default:
                        break;
                }
            })
        }
    }
    
    // Инициализация аналитики сайта
    ab_analytics.init();
    
    
    // ---
    
    $ (function () {
        $ (document).on ("uiEvent", function (e, data) {
            window.dataLayer.push (data);
        });
        
        
        // клик на любую книгу (переход на страницу книги)
        
        $ (document).on ("click", ".gtm-book-card__link", function (e) {
            const $card = $ (this).closest (".gtm-book-card");
            
            // собираем объект для аналитики
            $ (document).trigger ("uiEvent", [
                {
                    event: 'UI',
                    code: "bookCardClick",
                    data: {
                        bookId: globalFunctions.escapeStr ($card.data ("book-id")),
                        offerId: globalFunctions.escapeStr ($card.data ("book-offer-id")),
                        name: globalFunctions.escapeStr ($card.data ("book-name")),
                        publisher: globalFunctions.escapeStr ($card.data ("book-brand")),
                        categoryName: globalFunctions.escapeStr ($card.data ("book-category")),
                        variant: globalFunctions.escapeStr ($card.data ("book-variant")),
                        price: globalFunctions.escapeStr ($card.data ("book-price")),
                        list: globalFunctions.escapeStr ($card.data ("book-list")),
                        position: globalFunctions.escapeStr ($card.data ("book-position")),
                        sales: globalFunctions.escapeStr ($card.data ("book-issale"))
                    }
                }
            ]);
            
            // если айтем - это часть поисковой выдачи (для КиЛабс)
            if ($card.data ("kealabs-search-item") !== undefined) {
                $ (document).trigger ("uiEvent", [
                    {
                        event: 'UI',
                        code: "kealabsSearchItemClick",
                        data: {
                            offerId: globalFunctions.escapeStr ($card.data ("book-offer-id")),
                            kealabsRequestId: globalFunctions.escapeStr ($card.data ("kealabs-request-id"))
                        }
                    }
                ]);
                
            } else if ($card.data ("kealabs-widget-item") !== undefined) {
                $ (document).trigger ("uiEvent", [
                    {
                        event: 'UI',
                        code: "kealabsWidgetItemClick",
                        data: {
                            offerId: globalFunctions.escapeStr ($card.data ("book-offer-id")),
                            widgetId: globalFunctions.escapeStr ($card.data ("kealabs-widgetid")),
                            model: globalFunctions.escapeStr ($card.data ("kealabs-model"))
                        }
                    }
                ]);
            }
        });
        
        
        // просмотр рекомендации
        
        $ (window).on ("resize scroll", function () {
            $ ("[data-kealabs-widget-block]:not(\"._tracked\")").each (function () {
                const $_this = $ (this);
                
                if ($_this.isInViewport ()) {
                    $_this.addClass ("_tracked");
                    $ (document).trigger ("uiEvent", [
                        {
                            event: 'UI',
                            code: "kealabsWidgetView",
                            data: {
                                widgetId: globalFunctions.escapeStr ($_this.data ("kealabs-widgetid")),
                                model: globalFunctions.escapeStr ($_this.data ("kealabs-model"))
                            }
                        }
                    ]);
                }
            });
        });
    
    
        // событие добавления/удаления товара в корзине
        $ (document).on ("eventBasketChange", function (e, evData) {
            const evObj = {
                event: 'UI',
                code: (evData.item.isDecrease) ? "basketDel" : "basketAdd",
                data: evData
            };
        
            $ (document).trigger ("uiEvent", [evObj]);

            // События для ВК ОК должны быть только для бумажных книг
            if (evData.basketType === 'paper') {
                if (!evData.item.isDecrease) {
                    let _tmr = window._tmr || (window._tmr = [])
                    _tmr.push({
                        type: 'reachGoal',
                        id: OK_ACCOUNT_ID,
                        value: (evData.item.priceOld > 0 ? evData.item.priceOld : evData.item.price),
                        goal: 'addToCart',
                        params: { product_id: evData.item.offerId}
                    });
                    _tmr.push({
                        type: 'reachGoal',
                        id: OK_ACCOUNT_ID,
                        value: (evData.item.priceOld > 0 ? evData.item.priceOld : evData.item.price),
                        goal: 'vk_ecom_cart',
                        params: { product_id: evData.item.offerId}
                    });
                    _tmr.push({
                        type: 'itemView',
                        productid: '' + evData.item.offerId,
                        pagetype: 'cart',
                        list: OK_LIST_ID,
                        totalvalue: '' + (evData.item.priceOld > 0 ? evData.item.priceOld : evData.item.price),
                    });
                }
                
            } else if (evData.basketType === 'lectures') {
                // Отправка корзины Лектория
                document.dispatchEvent(new CustomEvent('ab.analytics.event', {
                    bubbles: true,
                    cancelable: true,
                    detail: {
                        eventCode: 'lectoriiBasketChange',
                        basketData: evData,
                    }
                }));
            }
        });
    
        // новый формат сбора данных для adv.cake (используется на страницах серий и подборок)
        if (
            typeof analyticsDataObject !== 'undefined' &&
            typeof analyticsAdvcakeData !== 'undefined') {
        
            // user во всех событиях
            analyticsAdvcakeData.user = {
                email: analyticsDataObject.user.md5 || ''
            };
            // basketProducts во всех, кроме главной
            if (analyticsAdvcakeData.pageType != 1) {
                if (analyticsDataObject.basketProducts && Object.keys (analyticsDataObject.basketProducts).length > 0) {
                    analyticsAdvcakeData.basketProducts = Object.keys (analyticsDataObject.basketProducts).map (function (key) {
                        return {
                            id: analyticsDataObject.basketProducts[key].id,
                            name: analyticsDataObject.basketProducts[key].name,
                            price: analyticsDataObject.basketProducts[key].price,
                            quantity: analyticsDataObject.basketProducts[key].quantity,
                            categoryId: analyticsDataObject.basketProducts[key].categoryId,
                            categoryName: analyticsDataObject.basketProducts[key].categoryName,
                        };
                    });
                }
            }
            // товары на странице
            if (typeof analyticsAdvcakeProductsWrap !== 'undefined') {
                analyticsAdvcakeData.products = [];
                $ (analyticsAdvcakeProductsWrap + ' .gtm-book-card').each ((i, el) => {
                    const $el = $ (el);
                    analyticsAdvcakeData.products.push ({
                        id: $el.attr ('data-book-offer-id'),
                        name: $el.attr ('data-book-name'),
                        price: $el.attr ('data-book-price'),
                    });
                });
            }
            // категория (страницы разделов или товара)
            // на страницах серий и подборок не должно передаваться
            if ((analyticsAdvcakeData.pageType == 2 || analyticsAdvcakeData.pageType == 3) && analyticsDataObject.category && (analyticsDataObject.category.id > 0 || analyticsDataObject.category.name)) {
                analyticsAdvcakeData.currentCategory = {
                    id: analyticsDataObject.category.id || '',
                    name: analyticsDataObject.category.name || '',
                };
            }
        
            window.advcake_data = window.advcake_data || [];
            window.advcake_data.push (analyticsAdvcakeData);
        }
        
        // --- Метрика
    
        // ToDo перенести события ниже в новый формат
        
        // триггер событий яндекс метрики
        // yaCode - код события в метрике
        $ (document).on ("yaEvent", (event, yaCode) => {
            if (typeof yaCounter1611177 != 'undefined') {
                yaCounter1611177.reachGoal(yaCode)
            }
        })
        
        // События метрики
        // клик на кнопку "В корзину" в детальной карточке товара (книги, сертификата или лекции)
        $ (document).on ('click', '.js-book-page__btn-buy, .js-cert-detail__buttons-buy, .js-lecture-page-buy', event => {
            const $target = $(event.target)
            if($target.data('isDigital')){
                $target.trigger('yaEvent', [('digitaltype' in event.target.dataset && event.target.dataset.digitaltype=='audio'?'audio':'elektronnaya')+'-kniga-vkorzinu']);
            }
            else {
                $target.trigger('yaEvent', [($target.hasClass('js-cert-detail__buttons-buy')) ? 'giftcard' : 'clickonbasket'])
            }
        })
        // клик на кнопку "В корзину" в превью товара
        $ (document).on ('click', '.js-book-card-buy__add, .js-book-item__buy-btn, .js-book-big-buy__btn_buy', event => {
            const $target = $(event.target)
            $target.trigger('yaEvent', ['catalogclickonbasket'])
            // если нажатие из блога, триггерим ещё одно событие
            if ($target.data('pageType') === 'blog')
                $target.trigger('yaEvent', ['basketfromblog'])
        })
        
        // успешная оплата товара
        // event.target - кнопка оплаты, по её дата-параметру определяем, оплачен обычный товар или сертификат
        $ (document).on ('product_pay_success', event => {
            const $target = $(event.target)
            if ($target.attr('data-product-type') === 'certificate') {
                $(event.target).trigger('yaEvent', ['giftcard_pokupka'])
            }
        })

        // Клик на кнопку "Перейти" или "В корзину" на детальной странице блога для товара без рамки
        $ (document).on ('click', '._blogPostPage.blog-detail-b-test .book-item-btns__basket-btn', event => {
            const analyticsEvent = new CustomEvent('ab.analytics.event', {
                bubbles: true,
                cancelable: true,
                detail: {
                    eventCode: 'blogProductWithoutBorderClick'
                }
            });
            document.dispatchEvent(analyticsEvent);
        })

        // Клик на кнопку "Перейти" или "В корзину" на детальной странице блога для товара с рамкой
        $ (document).on ('click', '._blogPostPage.blog-detail-a-test .book-item-btns__basket-btn', event => {
            const analyticsEvent = new CustomEvent('ab.analytics.event', {
                bubbles: true,
                cancelable: true,
                detail: {
                    eventCode: 'blogProductWithBorderClick'
                }
            });
            document.dispatchEvent(analyticsEvent);
        })
        
        // Переход в карточку товара на детальной странице блока для товара без рамки
        $ (document).on ('click', '._blogPostPage.blog-detail-b-test .gtm-book-card__link', event => {
            const analyticsEvent = new CustomEvent('ab.analytics.event', {
                bubbles: true,
                cancelable: true,
                detail: {
                    eventCode: 'blogProductWithoutBorderGoDetailClick'
                }
            });
            document.dispatchEvent(analyticsEvent);
        })

        // Переход в карточку товара на детальной странице блока для товара с рамкой
        $ (document).on ('click', '._blogPostPage.blog-detail-a-test .gtm-book-card__link', event => {
            const analyticsEvent = new CustomEvent('ab.analytics.event', {
                bubbles: true,
                cancelable: true,
                detail: {
                    eventCode: 'blogProductWithBorderGoDetailClick'
                }
            });
            document.dispatchEvent(analyticsEvent);
        })

        // Переход в Альпина.Плюс в шапке
        $ (document).on ('click', '.js-alpina-plus-header', event => {
            const analyticsEvent = new CustomEvent('ab.analytics.event', {
                bubbles: true,
                cancelable: true,
                detail: {
                    eventCode: 'alpinaPlusHeaderClick'
                }
            });
            document.dispatchEvent(analyticsEvent);
        })
        
        // Кнопка Доступно по подписке (для неавторизованных без подписки, которая будет вести на лендинг подписки в Плюсе)
        $ (document).on ('click', '.js-alpina-plus-cart', event => {
            const analyticsEvent = new CustomEvent('ab.analytics.event', {
                bubbles: true,
                cancelable: true,
                detail: {
                    eventCode: 'alpinaPlusCartClick'
                }
            });
            document.dispatchEvent(analyticsEvent);
        })

        // Кнопка Читать/Смотреть по подписке (для авторизованных с подпиской, которая ведет на потребление контента в плюсе)
        $ (document).on ('click', '.js-alpina-plus-read', event => {
            const analyticsEvent = new CustomEvent('ab.analytics.event', {
                bubbles: true,
                cancelable: true,
                detail: {
                    eventCode: 'alpinaPlusReadClick'
                }
            });
            document.dispatchEvent(analyticsEvent);
        })
    })
} ());
